import React, { Component } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  Grid,
  CircularProgress,
  Collapse,
  Alert,FormControl,Select,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
//import axios from 'axios';
import {NavLink, Navigate  } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import Serverurl from './Apiurl';
import axiosInstance from "./axiosConfig";
const MAX_IMAGES = 5;
class AddService extends Component {
  constructor(props) {
    super(props);
	this.editor = React.createRef();
    this.state = {
      sm_title: '',
      sm_description: '',
	  sm_tagline:'',
	  sm_icon:[],
      existingImages: [],
      newImages: [], protectedImages: {},
existingIcons: [],
newIcons: [],
      errors: {},
      loading: false,
      submitText: 'Submit',
      alertOpen: false,
      alertMessage: '',
      alertSeverity: 'error',
	  sm_type:'',
	  sm_servicetype:''
    };
    this.newImagePreviews = [];
this.newIconPreviews = [];
    this.handleImageChange = this.handleImageChange.bind(this);
    this.removeExistingImage = this.removeExistingImage.bind(this);
    this.removeNewImage = this.removeNewImage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
this.handleIconChange = this.handleIconChange.bind(this);
this.removeExistingIcon = this.removeExistingIcon.bind(this);
this.removeNewIcon = this.removeNewIcon.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
  }
  getServiceIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('id');
  }
  componentDidMount() 
  {
	   document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    const id = this.getServiceIdFromUrl();
    if (id) {
      this.fetchService(id);
    } else {
      this.resetForm();
    }
  }
  loadProtectedImage = async (filename) => {
  if (!filename || this.state.protectedImages[filename]) {
    return;
  }

  try {
    const response = await axiosInstance.get(
      `${Serverurl}api/files/${filename}`,
      {
        responseType: 'blob',
      }
    );

    const imageUrl = URL.createObjectURL(response.data);

    this.setState((prevState) => ({
      protectedImages: {
        ...prevState.protectedImages,
        [filename]: imageUrl,
      },
    }));
  } catch (error) {
    console.error("Failed to load image:", filename, error);
  }
};
removeExistingImage = (index) => {
  const updated = [...this.state.existingImages];
  updated.splice(index, 1);
  this.setState({ existingImages: updated });
};
  componentDidUpdate(prevProps) {
    const prevId = new URLSearchParams(window.location.search).get('id');
    const currentId = this.getServiceIdFromUrl();
    if (prevId !== currentId) {
      this.newImagePreviews.forEach(URL.revokeObjectURL);
      this.newImagePreviews = [];
      if (currentId) {
        this.fetchService(currentId);
      } else {
        this.resetForm();
      }
    }
  }
  componentWillUnmount() {
    this.newImagePreviews.forEach(URL.revokeObjectURL);
this.newIconPreviews.forEach(URL.revokeObjectURL);	
  }
  resetForm() {
    this.setState({
      sm_title: '',
      sm_description: '',
	 // sm_tagline:'',
	  sm_icon: [],
	existingImages: [],
	newImages: [],
	existingIcons: [],
	newIcons: [],
      errors: {},
      alertOpen: false,
      alertMessage: '',
      alertSeverity: 'error',
	  sm_type:'',
	  sm_servicetype:'',
    });
  }
  fetchService(id) {
    this.setState({ loading: true });
    axiosInstance
  .get(`${Serverurl}servicemanagement/servicemanagementgetbyid/${id}`)
.then((res) => {
  const { service, images } = res.data;

  this.setState({
    sm_title: service.sm_title || '',
    sm_description: service.sm_description || '',
    sm_tagline: service.sm_tagline || '',
    sm_icon: service.sm_icon || '',
    existingImages: images || [],
    newImages: [],

existingIcons: service.sm_icon
  ? [
      {
        url: service.sm_icon
      }
    ]
  : [],

    newIcons: [],
    errors: {},
    loading: false,
    alertOpen: false,
    alertMessage: '',
    sm_type: service.sm_type || '',
    sm_servicetype: service.sm_servicetype || '',
  });

  if (service.sm_icon) {
    this.loadProtectedImage(service.sm_icon);
  }

  (images || []).forEach((image) => {
    if (image.url) {
      const filename = image.url.replace(/^uploads\//, "");
      this.loadProtectedImage(filename);
    }
  });

  this.newImagePreviews.forEach(URL.revokeObjectURL);
  this.newImagePreviews = [];
})
      .catch(() => {
        this.setState({ loading: false });
        alert('Failed to fetch service data.');
      });
  }
  showAlert(message, severity = 'error') {
    this.setState({ alertOpen: true, alertMessage: message, alertSeverity: severity });
  }
  closeAlert() {
    this.setState({ alertOpen: false, alertMessage: '' });
  }
  validate() {
    const { sm_title, sm_description,sm_tagline, existingImages, newImages, sm_servicetype, sm_type } = this.state;
    let tempErrors = {};
    if (!sm_title.trim()) tempErrors.sm_title = 'Title is required';
    if (!sm_description.trim()) tempErrors.sm_description = 'Description is required';
	 if (!sm_tagline.trim()) tempErrors.sm_tagline = 'Tagline is required';
	 if (!sm_type) tempErrors.sm_type = 'Type is required';
	 if (!sm_servicetype) tempErrors.sm_servicetype = 'Service Type is required';
    if (existingImages.length + newImages.length === 0)
      tempErrors.images = 'Please select at least one image.';
if(this.state.existingIcons.length + this.state.newIcons.length===0)
    tempErrors.icons="Please upload icon.";
    if (Object.keys(tempErrors).length > 0) {
      this.setState({ errors: tempErrors });
      const firstError =
  tempErrors.sm_title ||
  tempErrors.sm_description ||
  tempErrors.sm_tagline ||
  tempErrors.sm_type ||
  tempErrors.sm_servicetype ||
  tempErrors.images ||
  tempErrors.icons;
      this.showAlert(firstError, 'error');
      return false;
    }
    this.setState({ errors: {} });
    this.closeAlert();
    return true;
  }
 handleImageChange(e) {
  const files = Array.from(e.target.files);
  const allowedTypes = ['image/jpeg', 'image/png'];
  const filteredFiles = files.filter(file => allowedTypes.includes(file.type));
  if (filteredFiles.length !== files.length) {
    this.showAlert('Only JPG and PNG files are allowed.', 'warning');
  }
  const { existingImages, newImages } = this.state;
  const totalCount = existingImages.length + newImages.length + filteredFiles.length;
  if (totalCount > MAX_IMAGES) {
    this.showAlert(`You can only upload up to ${MAX_IMAGES} images.`, 'warning');
    return;
  }
  // Revoke old previews
  this.newImagePreviews.forEach(URL.revokeObjectURL);
  this.newImagePreviews = filteredFiles.map((file) => URL.createObjectURL(file));
  this.setState({ newImages: filteredFiles });
}
handleIconChange(e) {
    const files = Array.from(e.target.files);
    this.newIconPreviews.forEach(URL.revokeObjectURL);
    this.newIconPreviews = files.map(file =>
        URL.createObjectURL(file)
    );
    this.setState({
        newIcons: files
    });
}
removeExistingIcon(index) {
    const updated=[...this.state.existingIcons];
    updated.splice(index,1);
    this.setState({
        existingIcons:updated
    });
}
removeNewIcon(index){
    const updated=[...this.state.newIcons];
    updated.splice(index,1);
    URL.revokeObjectURL(this.newIconPreviews[index]);
    this.newIconPreviews.splice(index,1);
    this.setState({
        newIcons:updated
    });
}
  removeNewImage(index) {
    const updated = [...this.state.newImages];
    updated.splice(index, 1);
    URL.revokeObjectURL(this.newImagePreviews[index]);
    this.newImagePreviews.splice(index, 1);
    this.setState({ newImages: updated });
  }
  handleSubmit() {
    if (!this.validate()) return;
    this.setState({ loading: true, submitText: 'Processing...' });
    const id = this.getServiceIdFromUrl();
    const formData = new FormData();
    formData.append('sm_title', this.state.sm_title);
    formData.append('sm_description', this.state.sm_description);
	 formData.append('sm_tagline', this.state.sm_tagline);
	 formData.append('sm_typeOfService', JSON.stringify([]));
    formData.append('userid', 1);
	 formData.append('sm_type', this.state.sm_type);
	  formData.append('sm_servicetype', this.state.sm_servicetype);
    formData.append('existingImages', JSON.stringify(this.state.existingImages));
formData.append('existingIcons',JSON.stringify(this.state.existingIcons));
    this.state.newImages.forEach((file) => {
      formData.append('ga_image', file);
    });
	this.state.newIcons.forEach((file) => {
		formData.append('sm_icon', file);
	});
let request;
   if (id) {
    request = axiosInstance.put(`${Serverurl}servicemanagement/servicemanagementupdate/${id}`,formData,
	{ headers: { "Content-Type": "multipart/form-data" } }
    );
  } else {
      request=axiosInstance.post(Serverurl+"servicemanagement/servicemanagementinsert",formData,
	    { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
request
    .then(() => {
      window.location.href = "/ServiceManagement";  
    })
      .catch(() => {
        this.setState({ loading: false, submitText: 'Submit' });
        this.showAlert('Failed to save service.', 'error');
      });
  }
  render() {
if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
    const isEditMode = !!this.getServiceIdFromUrl();
    return (
	      <div className="maincontentDiv">
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
           <NavLink  to="/serviceManagement" ><Button
            variant="contained"
            className="frmPrimarybtn"
            startIcon={<ArrowBackIcon />}
			size="small"
			style={{
    marginTop: '15px'
}}
          >
            Back
          </Button></NavLink>
        </Box>
        <Collapse in={this.state.alertOpen}>
          <Alert
            severity={this.state.alertSeverity}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={this.closeAlert}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {this.state.alertMessage}
          </Alert>
        </Collapse>
        <Typography sx={{textAlign:'center'}} className="contentHeading" variant="h5" gutterBottom>
          {isEditMode ? 'Service' : 'Service'}
        </Typography>
<Box sx={{ display: "flex", gap: 2, width: "100%" }}>
  <Box sx={{ flex: 1 ,width:"50%" }}>
    <p>Title <span className="validation"> * </span></p>
    <TextField
      fullWidth
      size="small"
      value={this.state.sm_title}
      onChange={(e) => this.setState({ sm_title: e.target.value })}
      placeholder="Enter Title"
    />
  </Box>
{/*
  <Box sx={{ flex: 1 }}>
    <p>Tagline <span className="validation"> * </span></p>
    <TextField
      fullWidth
      size="small"
      value={this.state.sm_tagline}
      onChange={(e) => this.setState({ sm_tagline: e.target.value })}
      placeholder="Enter Tagline"
    />
  </Box>
*/}
      <Box sx={{ flex:1, width:"50%" }}>
		<p >Icon<span className="validation">*</span></p>
          <input
            accept="image/*"
            id="service-icon-upload"
            multiple
            type="file"
            onChange={this.handleIconChange}
            style={{ display: 'none' }}
            disabled={this.state.loading}
          />
          <label htmlFor="service-icon-upload">
			<Grid container spacing={2} sx={{ mt: 2 }}>
			{this.state.existingIcons.map((img,idx)=>(
			<Grid item key={idx}>
			<Box sx={{position:'relative',width:80,height:80}}>
			<img
			src={
  this.state.protectedImages[
    img.url.replace(/^uploads\//, "")
  ]
}
			style={{width:'100%',height:'100%',objectFit:'contain'}}
			/>
			<IconButton
			size="small"
			onClick={()=>this.removeExistingIcon(idx)}
			sx={{position:'absolute',top:0,right:0}}
			>
			<CloseIcon fontSize="small"/>
			</IconButton>
			</Box>
			</Grid>
			))}
			{this.state.newIcons.map((file,idx)=>(
			<Grid item key={idx}>
			<Box sx={{position:'relative',width:80,height:80}}>
			<img
			src={this.newIconPreviews[idx]}
			style={{width:'100%',height:'100%',objectFit:'contain'}}
			/>
			<IconButton
			size="small"
			onClick={()=>this.removeNewIcon(idx)}
			sx={{position:'absolute',top:0,right:0}}
			>
			<CloseIcon fontSize="small"/>
			</IconButton>
			</Box>
			</Grid>
			))}
			</Grid>
            <Button size="small"
			variant="contained" className="frmPrimarybtn" component="span" disabled={this.state.loading}>
              Upload icons
            </Button>
          </label>
        </Box>
</Box>
<p>Description<span className="validation"> * </span></p>
   <JoditEditor
  ref={this.editor}
  value={this.state.sm_description}
  onBlur={newContent => this.setState({ sm_description: newContent })}
  tabIndex={1} 
  placeholder="Enter Description"
/>
        <Box sx={{ mt: 2, mb: 1 }}>
          <input
            accept="image/*"
            id="service-image-upload"
            multiple
            type="file"
            onChange={this.handleImageChange}
            style={{ display: 'none' }}
            disabled={this.state.loading}
          />
          <label htmlFor="service-image-upload">
            <Button size="small"
			variant="contained" className="frmPrimarybtn" component="span" disabled={this.state.loading}>
              Upload Images
            </Button>
          </label>
        </Box>
        <Grid container spacing={2}>
          {this.state.existingImages.map((img, idx) => (
            <Grid item key={idx}>
              <Box
                sx={{
                  position: 'relative',
                  width: 80,
                  height: 80,
                  border: '1px solid #ccc',
                  borderRadius: 1,
                  overflow: 'hidden',
                }}
              >
               <img
  src={
    this.state.protectedImages[
      img.url.replace(/^uploads\//, "")
    ]
  }
  alt={`existing-${idx}`}
  style={{
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  }}
/>
                <IconButton
                  size="small"
                  onClick={() => this.removeExistingImage(idx)}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bgcolor: 'rgba(255,255,255,0.7)',
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            </Grid>
          ))}
          {this.state.newImages.map((file, idx) => (
            <Grid item key={idx}>
              <Box
                sx={{
                  position: 'relative',
                  width: 80,
                  height: 80,
                  border: '1px solid #ccc',
                  borderRadius: 1,
                  overflow: 'hidden',
                }}
              >
                <img
                  src={this.newImagePreviews[idx]}
                  alt={`new-${idx}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <IconButton
                  size="small"
                  onClick={() => this.removeNewImage(idx)}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bgcolor: 'rgba(255,255,255,0.7)',
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            </Grid>
          ))}
        </Grid>
		<p>Type<span className="validation"> * </span></p>
          <FormControl fullWidth>
           <Select
  native
  size="small"
  name="sm_type"
  value={this.state.sm_type}
  onChange={(e) => this.setState({ sm_type: e.target.value })}
>
  <option value="">Select Type</option>
  <option value="1">Premium Service</option>
  <option value="2">Service</option>
</Select>
          </FormControl>
		  <p>Service Type<span className="validation"> * </span></p>
          <FormControl fullWidth>
            <Select native size="small" name="sm_servicetype" value={this.state.sm_servicetype} onChange={(e) => this.setState({ sm_servicetype: e.target.value })}>
              <option value="">Select Service Type</option>
              <option value="1">Service Quote</option>
              <option value="2">Inspection </option>
            </Select>
          </FormControl>
        <Box sx={{ textAlign:'right',pb:3,mt: 3 }}>
          <Button
		  size="small"
            variant="contained"
            className="frmPrimarybtn"
            onClick={this.handleSubmit}
            disabled={this.state.loading}
          >
            {this.state.submitText}
          </Button>
          {this.state.loading && (
            <CircularProgress
              size={24}
              sx={{
                color: 'primary.main',
                position: 'relative',
                top: '6px',
                left: '10px',
              }}
            />
          )}
        </Box>
      </Container></div>
    );
  }
}
export default AddService;